(() => {
  const mobile = window.matchMedia('(max-width: 700px)');

  const makeDisclosure = (section, label) => {
    if (!section || section.parentElement?.matches('[data-cha-mobile-disclosure]')) return;
    const details = document.createElement('details');
    details.dataset.chaMobileDisclosure = '';
    details.open = !mobile.matches;
    const summary = document.createElement('summary');
    summary.textContent = label;
    section.before(details);
    details.append(summary, section);
  };

  const prepareSecondaryPages = () => {
    document.querySelectorAll('.cha-support__section').forEach((section, index) => {
      if (index >= 2) makeDisclosure(section, section.querySelector('h2')?.textContent?.trim() || 'More support information');
    });
    [
      ['#why-authorized', 'Why buy from an authorized dealer'],
      ['#dealer-resources', 'Buying resources'],
      ['#dealer-support', 'Technical support'],
      ['#become-a-dealer', 'Become a dealer'],
      ['#mil-radios', 'Radio and feed-line planning'],
      ['#mil-resources', 'Operator resources'],
      ['#mil-evidence', 'Field evidence'],
      ['#mil-nec-guide', 'How to read NEC patterns'],
      ['#mil-nec', 'Engineering pattern library'],
      ['#mil-sustainment', 'Sustainment and lifecycle'],
      ['#mil-buy', 'Buying and program pathways']
    ].forEach(([selector, label]) => makeDisclosure(document.querySelector(selector), label));

    document.querySelectorAll('[data-cha-mobile-disclosure]').forEach(details => {
      details.open = !mobile.matches;
    });
    if (location.hash) {
      const target = document.querySelector(location.hash);
      target?.closest('[data-cha-mobile-disclosure]')?.setAttribute('open', '');
    }
  };

  const prepareLegacyProductCopy = () => {
    document.querySelectorAll('.cha-product-content__section--legacy').forEach(section => {
      if (section.parentElement?.matches('.cha-product-legacy-disclosure')) return;
      const details = document.createElement('details');
      details.className = 'cha-product-legacy-disclosure';
      const summary = document.createElement('summary');
      summary.textContent = 'Complete product details';
      section.querySelector(':scope > h3')?.remove();
      section.before(details);
      details.append(summary, section);
    });
  };

  const relocateProductReviews = () => {
    const platform = document.querySelector('.chameleon-product-platform');
    const reviews = document.querySelector('[id*="yotpo_product_reviews_reviews_Wif8pY"]');
    if (!platform || !reviews || reviews.classList.contains('cha-product-reviews-relocated')) return;
    reviews.classList.add('cha-product-reviews-relocated');
    platform.after(reviews);
    return true;
  };

  const openHashDisclosure = event => {
    const link = event.target.closest('a[href*="#"]');
    if (!link) return;
    let url;
    try { url = new URL(link.href, location.href); } catch { return; }
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
    document.querySelector(url.hash)?.closest('[data-cha-mobile-disclosure]')?.setAttribute('open', '');
  };

  const init = () => {
    prepareSecondaryPages();
    prepareLegacyProductCopy();
    if (!relocateProductReviews() && document.querySelector('.chameleon-product-platform')) {
      const reviewObserver = new MutationObserver(() => {
        if (relocateProductReviews()) reviewObserver.disconnect();
      });
      reviewObserver.observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('click', openHashDisclosure);
    mobile.addEventListener?.('change', prepareSecondaryPages);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
